import $ from 'jquery';
import {refreshUtmFields} from './form-utils.js';

export function initPublicationInlineComponents(root = document) {
  root.querySelectorAll('[data-inline-publication]').forEach((component) => {
    if (component.dataset.inlinePublicationInitialized === 'true') {
      return;
    }

    component.dataset.inlinePublicationInitialized = 'true';

    component.querySelectorAll('[data-show-publication-below-the-fold]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const formWrapper = document.getElementById(trigger.dataset.showPublicationBelowTheFold);

        if (!formWrapper) {
          return;
        }

        trigger.hidden = true;
        $(formWrapper).slideDown(1000);

        window.setTimeout(() => {
          formWrapper.classList.remove('unfold');
          refreshUtmFields(formWrapper);
        }, 2000);
      }, {once: true});
    });
  });
}
